var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1330.979,
    height: 1433.655,
    viewBox: "0 0 1330.979 1433.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5494",
    "data-name": "Group 5494",
    transform: "matrix(-0.766, -0.643, 0.643, -0.766, 696.876, 1503.13)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M49.3,185.075c-.661-15.5-6.376-30.087-10.12-45.036s-5.3-32.051,1.687-44.991c3.779-7,9.7-12.048,13.526-19.012,8.9-16.221,4.6-38.822,12.083-56.038C72.767,5.531,88.256-2.768,101.451,2.606S122.935,27.5,117.434,42.427c-5.117,13.883-19,20.324-25.559,33.3-6.9,13.644-4.168,31.713,2.252,46.005s16.061,26.208,23.691,39.663,13.369,29.806,10.4,45.39c-1.176,6.172-3.841,12.126-8.224,15.691-10.631,8.649-26.2-.586-33.043-13.868-2.461-4.777-4.5-10.336-8.631-13.052-6.34-4.168-14.55.924-17.9,8.366s-3.256,16.365-3.411,24.867c-.266,14.7-1.722,30.024-8.6,42.106s-20.637,19.68-32.129,13.785C4.441,278.609-.4,259.768,4.61,245.956,15.426,216.145,51.094,227.125,49.3,185.075Z",
    transform: "translate(409.386 369.618)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M44.037,80.431c2.978-1.128,5.192-4.238,6.216-7.733,1.819-6.218.193-13.249-2.493-19.124S41.378,42.525,38.616,36.7c-3.9-8.239-5.879-17.663-10.417-25.444S15.062-2.471,7.883,1.287C3.3,3.687.519,9.612.206,15.575-.361,26.4,6.674,32.58,8.55,42.253c1.544,7.965-1.491,11.222,5.239,16.127,5.141,3.744,12.837,1.9,17.452,7.059C35.737,70.469,34.634,83.993,44.037,80.431Z",
    transform: "translate(465.381 486.918)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M.38,9.469a16.733,16.733,0,0,1-.3-2.555C-.036,4.016.649,1.081,2.843.235,10.874-2.843,4.785,31.689.38,9.469Z",
    transform: "translate(480.274 503.946)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M39.28,169.784c1.56,17.745,8.69,35.766,4.4,52.726-3.949,15.625-16.4,25.475-25.21,37.922C4.871,279.656-.137,307.03,5.45,331.623c1.784,7.853,4.706,15.625,9.724,21.244,7.075,7.924,17.209,10.459,26.818,11.623,8.976,1.087,18.439,1.172,26.4-3.616C87.207,349.547,88.9,317.927,103.545,300c16.317-19.984,44.257-18.352,64.069-33.313,13.01-9.824,21.8-26.972,23.23-45.294s-4.549-37.442-15.777-50.5c-3.712-4.316-7.956-8-11.324-12.691-8.259-11.5-10.1-28.815-4.473-42.043,2.491-5.855,6.238-10.818,8.928-16.544,5.509-11.728,6.232-25.914,5.049-39.407-1.073-12.221-3.677-24.492-9.109-35.064s-13.929-19.333-24-22.479c-14.555-4.547-30.054,3.3-40.622,15.6-9.885,11.5-16.2,26.33-22.181,40.966C72.524,71,71.715,81.718,68.531,93.7c-3.557,13.4-15.207,20.86-21.162,32.746C40.533,140.092,39.12,154.144,39.28,169.784Z",
    transform: "translate(384.398 330.734)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M49.807,223.414c-2.31,10.18-8.549,18.238-14.006,26.5C12.559,285.129,1.074,331.046,4.239,376.1c1.269,18.049,5.1,36.658,14.971,50.7,12.575,17.9,32.811,25.467,52.173,28.347,18.89,2.809,39.406,1.513,54.473-11.8,19.98-17.651,24.911-51.029,41.838-72.68,15.649-20.015,39.489-27.61,58.558-42.949,26.532-21.344,43.111-58.816,42.983-97.151-.027-8.223-.867-16.793-4.569-23.844-3.324-6.332-8.612-10.805-13.135-16.005-13.126-15.092-19.944-37.513-17.868-58.751,1.138-11.637,4.747-22.658,6.822-34.09,3.216-17.716,2.623-36.747-3.257-53.708S219.9,12.564,205.439,6c-14.64-6.643-31.2-4.646-45.555,2.143s-26.82,18.025-38.493,29.931c-12.616,12.866-23.019,26.587-30.1,44.627-6.1,15.546-11.651,30.682-19.7,44.963-6.32,11.209-12.066,22.186-16.271,34.827-3.222,9.684-5.6,18.806-5.473,29.368S52.163,213.039,49.807,223.414Z",
    transform: "translate(349.42 311.738)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M130.806,121.942c-17.505,20.28-35.774,42.124-41.312,70.535-2.162,11.091-2.432,23.279-8.013,32.479s-15.216,13.329-23.774,18.452C30.3,259.82,9.959,291.5,3.862,327.3c-.635,3.735-.937,8.208,1.446,10.852,2.874,3.191,7.387,1.494,11.278,1.26,8.565-.519,16.365,7.519,19.688,16.968s3.072,20,2.312,30.1c-1.925,25.58-6.669,52.061.548,76.51,8.349,28.277,31.926,47.981,56.652,54.037s50.347.247,73.852-9.755c26.887-11.44,53.887-30.911,63.409-62.8,2.935-9.826,4.131-20.612,8.958-29.293,3.89-7,9.8-11.991,15.577-16.824l39.069-32.689c15.392-12.877,31.121-26.158,41.622-44.687,8.776-15.486,13.414-33.9,15.574-52.5,2.907-25.027.619-53.288-14.462-71.643-7.02-8.542-16.607-14.722-20.828-25.508-7.732-19.76,6.464-40.438,11.846-60.948,4.21-16.039,2.823-33.865-2.471-49.687C313.319,17.021,267.284-7.862,230.147,6.855c-12.425,4.925-23.548,13.476-33.9,22.882a287.262,287.262,0,0,0-56.664,71.675Z",
    transform: "translate(285.217 291.561)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M7.73,44.547C4.895,48.365,1.984,52.394.946,57.355s.431,11.116,4.4,13.3c5.4,2.978,12.33-2.514,17.36,1.286a10.947,10.947,0,0,1,3.053,4.132c5.96,12.659-.769,27.857-1.084,42.206-.068,3.126.845,7.151,3.476,7.516,2.485.345,4.06-2.937,4.776-5.747C36.27,106.938,35.842,92.707,39.2,79.6,42.923,65.05,50.972,53.1,58.6,41.235c5.952-9.251,17.049-23.484,7.718-35C48.695-15.5,17.512,31.379,7.73,44.547Z",
    transform: "translate(306.455 540.438)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M2.6,18.642c-2,3.785-3.012,8.578-1.77,12.87S6,39.16,9.7,38.185C14.955,36.8,16.365,29,19.451,23.83,22.59,18.57,35.309,5.577,23.855.623,16.905-2.384,5.867,12.472,2.6,18.642Z",
    transform: "translate(328.805 564.527)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M34.788,8.278C28.24,4.644,21.623.231,14.449.149S-.47,6.432.182,14.9c.528,6.863,6.06,11.717,11.443,14.448s11.371,4.5,15.539,9.4c2.907,3.415,4.614,8.023,7.415,11.559,3.934,4.964,9.614,7.335,15.12,9.177,5.108,1.707,10.552,3.116,15.608,1.44s9.452-7.431,8.566-13.611c9.773-1.627,18.712-8.664,23.7-18.657,3.947-7.907-1.406-14.277-8.53-14.147-4.426.081-7.283,3.965-11.3,5.329C64.836,24.228,46.513,14.786,34.788,8.278Z",
    transform: "translate(378.29 692.545)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M11.205,1.013C7.693-.088,3.295-.876,1.088,2.458-.382,4.68-.153,8.016,1.042,10.52a18.29,18.29,0,0,0,5.169,5.991A77.65,77.65,0,0,0,23.949,27.649C31.4,31,45.976,28.077,41.05,14.54,37.508,4.8,18.658,3.349,11.205,1.013Z",
    transform: "translate(402.877 710.151)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M203,107.183c-6.944,17.2-8.412,37.688-18.283,52.7-6.6,10.032-16.231,16.462-25.081,23.675-25.776,21-46.428,50.583-59.043,84.559-6.961,18.749-10.919,42.578.249,58.7,6.831,9.861,18.247,14.9,23.3,26.142,2.6,5.785,3.144,12.473,3.636,18.958l1.932,25.527c1.536,20.3,2.978,41.451-3.274,60.246s-22.716,34.287-39.609,30.094a16.648,16.648,0,0,1-10.264-6.893c-3.106-4.848-3.243-11.385-2.989-17.394.923-21.772,5-44.922-3.453-64.528-4.566-10.6-12.289-18.745-19.244-27.366-26.4-32.717-43.441-75.788-47.632-120.38-2.284-24.295-.354-50.557,12.23-69.563,10.446-15.776,27.828-24.687,44.906-23.02,5.376.525,10.83,2.021,16.087.76,7.716-1.849,13.586-9.408,16.969-17.779s4.762-17.68,6.858-26.649c3.98-17.033,10.592-33,18.078-48.211,8.462-17.2,18.274-33.815,31.4-46.226S179.735.22,196.648,2.307c4.68.577,10.428,3.443,10.414,9-.015,5.583-6.1,8.9-6.3,14.47-.238,6.693,7.754,9.322,13.141,7.376,8.424-3.043,17.8-9.238,23.1,3.386,2.873,6.839,2.1,17.863-.948,24.356C227.812,78.479,210.755,87.97,203,107.183Z",
    transform: "translate(161.337 339.698)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M111.738,32.659c-7.923,18.235-11.591,38.658-17.508,57.969S79.4,129.111,64.459,139.471c-10.809,7.5-24,9.812-34.081,18.586a59.508,59.508,0,0,0-11.514,14.5C1.857,200.98-2.32,239.719,8.041,272.94c5.485,17.585,16.875,35.089,32.557,36.993a17.937,17.937,0,0,0,15.993-5.8c6.079-7.112,6.147-18.621,5.5-28.83-1.4-22.232-4.284-44.867-.262-66.512,7.008-37.7,33.377-65.179,59.468-87.993,14.038-12.273,29.577-26.1,32.362-46.634.969-7.145.541-15.4,4.883-20.427,1.938-2.241,4.557-3.443,6.776-5.282,18.684-15.5-3.136-35.714-14.828-43.683C132.944-7.189,119.093,15.729,111.738,32.659Z",
    transform: "translate(184.997 374.068)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M1.761,58c2.181,3.972,7.251,4.531,10.633,2.166s5.316-6.822,6.439-11.293c2.518-10.032,3.725-18.413,10.117-26.135,2.533-3.06,12.023-7.73,12.87-11.877,1.448-7.093-8.492-9.211-12.763-10-7-1.3-17-1.167-21.391,6.439C3.995,13.657,4.992,24.528,4.187,31.86,3.429,38.773-1.785,51.538,1.761,58Z",
    transform: "translate(292.344 411.266)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M1.076,98.944c.372,9.053,2.455,19.48,9.358,23.565,6.433,3.809,14.619-.142,18.535-7.1S33.281,99.4,32.183,91.026,28.645,74.58,27.307,66.253c-1.894-11.793-1.39-24.573,3.83-34.685,3.71-7.188,22.789-19.725,16.536-28.575C40.779-6.763,27.7,14.262,23.706,20.006,8.53,41.809-.1,70.292,1.076,98.944Z",
    transform: "translate(200.617 531.905)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M1,22.261C.461,25.915-.03,29.68.606,33.342s2.639,7.252,5.644,8.429c3.8,1.486,8.049-1.509,9.623-5.791s.928-9.365-.686-13.705a38.988,38.988,0,0,1-1.815-5.167,42.482,42.482,0,0,1-.546-4.834C12.387,7.928,10.618-1.814,5.545.393,2.583,1.681,1.52,18.784,1,22.261Z",
    transform: "translate(209.131 599.923)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M1.068,28.694c1.754,4.59,6.14,6.769,9.311,10.148,7.109,7.575,7.527,20.485,6.006,31.5s-4.421,22.283-2.02,33.18a11.762,11.762,0,0,0,2.32,5.336,9.732,9.732,0,0,0,3.129,2.153c4.506,2.195,9.52,3.474,14.19,2.1a13.306,13.306,0,0,0,9.257-11.6c.232-3.173-.67-6.311-1.283-9.433-2.2-11.235-.7-22.887,1-34.147S46.574,35.2,45.12,23.809C43.276,9.371,36.242-3.767,23.311,1.474,15.458,4.656-3.949,15.567,1.068,28.694Z",
    transform: "translate(231.363 691.388)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M8.143,29.829c-.236,2.255-.772,4.589-.156,6.764s3.081,3.8,4.5,2.3c1.479-3.058,2.99-6.242,3.239-9.779.454-6.438-3.386-16.222-5.281-22.294C8.82,1.6,11.866-.778,4.943.356-8.084,2.489,9.157,20.092,8.143,29.829Z",
    transform: "translate(252.242 721.408)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M18.517,38.8C13.234,44.205,8.105,50.133,5.1,57.612,1.678,66.118,1.283,75.889.946,85.37c-.088,2.49-.154,5.11.815,7.348C3.48,96.69,7.781,98,11.514,97.88c5.174-.164,10.157-2.183,15.314-2.635s11.02,1.142,13.9,6.308c1.392,2.5,1.908,5.514,3.035,8.188,3.841,9.105,15.538,11.793,21.72,4.991,14.06-15.472-2.667-42.687,16.446-56.907,13.081-9.731,28.062-7.327,27.542-31.242C108.237-30.272,34.209,22.763,18.517,38.8Z",
    transform: "translate(363.463 91.31)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M.937,89.023C1.611,103.9,14.906,112.715,24.76,122.2c24.428,23.527,32.823,64.245,29.464,100.838s-16.58,70.481-28.6,104.222c-4.555,12.78-9.044,26.656-6.434,40.349,2.881,15.116,15.16,27.174,28.2,27.687,11.415.451,22.066-7.134,29.472-17.226s12.1-22.541,16.69-34.793l18.911-50.487c2.21-5.9,4.514-11.958,8.474-16.367,5.152-5.732,12.372-7.9,18.793-11.455,30.932-17.105,41.028-64.064,68.042-88.638,12.561-11.425,28.463-17.659,39.392-31.224,13.019-16.158,16.775-40.512,14.151-62.919S254.217,35.955,242,18.338c-28.561-41.176-79.781,7.369-83.193,25.211-3.947,20.646-10.447,100.173-42.994,76.511-22.141-16.1-29.745-46.367-57.535-54.754C41.209,60.153-.541,56.322.937,89.023Z",
    transform: "translate(678.888 36.19)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M451.62,61.475c-31.533,37.733-52.236,86.615-66.006,137.36-12.864,47.4-21.061,99.194-49.221,135.9-29.921,39-78.42,55.093-103.178,98.915-19.925,35.263-21.1,83.216-44.4,115.414-18.222,25.179-46.677,36.051-74.033,43.978s-56.042,14.5-78.626,34.136S-.836,684.249,11.795,714.535c10.321,24.748,34.263,36.515,56.332,45.256,49.078,19.437,76.588,47.145,127.957,45.261,67.1-2.46,58.489-42.418,62.406-50.835a928.935,928.935,0,0,0,54.027-148.231c9.85-36.248,18.228-74.634,39.325-103.17,19.946-26.978,48.8-41.791,75.491-58.863a489.964,489.964,0,0,0,87.3-71.564c18.77-19.335,36.512-40.778,48.2-66.829,12.615-28.1,17.591-60.176,21.5-91.841,1.187-9.625,2.282-19.549.287-29.063-9.249-44.151-71.655-44.476-84.4-87.47-6.167-20.8,3.022-44.309,17.612-57.421S567.47,55,569.59,19.526,483.153,23.742,451.62,61.475Z",
    transform: "translate(381.063 344.099)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M310.781,73.035c-5.065,18.81-7.194,38.637-11.983,57.554-26.038,102.87-122.343,156.92-163.941,252.025-10.188,23.293-17.159,49.187-31.938,68.668C91.751,466.007,76.885,476,62.078,485.262c-14.869,9.3-30.3,18.431-41.6,33.134-16.33,21.26-20.86,57.367-4.238,79.128,13.936,18.243,38.541,20.784,57.048,10.621s31.575-30.551,40.432-52.3,14.182-45.309,21.716-67.767c16.24-48.4,42.441-90.864,68.375-132.759,11.914-19.248,23.953-38.659,39.1-54.386,14.155-14.7,30.671-25.807,46.663-37.613A710.508,710.508,0,0,0,401.167,160.459c12.439-14.162,24.65-29.27,31.819-47.908,20.269-52.7-15.371-80.881-50.8-102.6C343.912-13.518,321.192,34.379,310.781,73.035Z",
    transform: "translate(481.768 482.889)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M1.678,162.295c1.011,11.112,16.551,3.326,22.641-3.094s9.286-15.768,12.162-24.835,5.774-18.486,11.485-25.373C57.32,97.71,71.845,95.721,84.553,90.653c14.477-5.772,27.51-16.282,37.294-30.075,30.03-42.336-33.781-76.828-58.961-50.521C53.481,19.884.666,151.185,1.678,162.295Z",
    transform: "translate(775.311 534.806)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M6.415,80.494C-4.763,78.246,3.534,57.327,6.27,46.231s7.465-21.29,12.157-31.386c1.379-2.967,2.848-6.053,5.248-7.893a15.49,15.49,0,0,1,5.579-2.369Q37.6,2.321,46.068.65a3.311,3.311,0,0,1,2.706.258,4.724,4.724,0,0,1,1.351,2.641C56.263,26.866,55.293,69.484,38.1,80.286S17.594,82.742,6.415,80.494Z",
    transform: "translate(527.509 975.616)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M3.518,54.9C6.511,43.138,12.6,31.284,22.48,27.535a5.01,5.01,0,0,1,2.883-.4c2.476.573,3.625,3.893,5.214,6.237,3.912,5.772,11.515,5.9,17.067,2.8s9.792-8.616,14.636-13.055S94.841-5.412,99.2,2.616,80.745,28.977,78.236,33.81c-1.9,3.661-5.266,5.8-8.309,8.14-18.264,14.068-6.72,81.332-12.584,89.309S-13.154,120.42,3.518,54.9Z",
    transform: "translate(413.35 955.732)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M143.378,1.478c-18.742-.193-46.311,33.236-69.467,49.853C67.147,56.187,60.232,61.2,55.355,68.559,46.787,81.5,45.933,99.686,48.69,116.035c2.583,15.32,8.013,30.657,5.9,45.962-2.378,17.221-13.658,30.2-22.666,43.869C15.961,230.081,5.948,259.787,3.366,290.595c-.913,10.89-.154,23.8,7.479,30.207,6.672,5.6,16.249,3.511,22.5-2.439s9.853-14.888,12.9-23.7c11.431-33.084,18.068-69.425,36.467-97.647,11.906-18.261,28-31.909,42.469-47.355s27.919-33.963,31.844-56.7C160.761,71.3,162.121,1.671,143.378,1.478Z",
    transform: "translate(791.478 796.971)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M57.023.588C51.618.532,31.13,22.038,18.183,32.764a54.132,54.132,0,0,0-8.951,8.678C.226,53.272.4,71.143,1.07,87.228c.151,3.628.406,7.566,2.446,10.326a9.358,9.358,0,0,0,6.777,3.529c8.178.81,15.949-4.922,21.258-12.175C78.181,25.2,62.43.644,57.023.588Z",
    transform: "translate(863.575 839.374)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M.965,68.653c-.675,5.567.02,12.72,4.5,14.772,3.129,1.435,6.646-.554,8.931-3.368s3.783-6.4,5.945-9.348c4.748-6.474,12.782-9.275,19.866-6.925,1.648.545,3.3,1.354,4.994,1.173,4.351-.466,6.181-6.838,5.982-12.018-.491-12.8-7.144-25.026-5.813-37.7.408-3.886,1.484-8.195-.4-11.474C43.234.739,39.681.055,36.658.537c-14.386,2.289-12.3,16.234-17.122,27.381C13.114,42.763,3.183,50.35.965,68.653Z",
    transform: "translate(716.069 850.901)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M207.687,259.867c42.334-18.959,7.205-85.164,30.38-116.969s54.663-53.533,86.975-71.139c20.484-11.16,104.48-47.345,91.684-65.78S236.327,122.824,156.64,123.763c-20.706.243-41.184-5.687-61.833-8.15s-42.689-1.025-59.8,12.367c-7.184,5.623-13.191,13.141-18.283,21.36-9.778,15.781-16.453,35.351-14.291,55s16.659,33.941,37.279,53.011S165.355,278.826,207.687,259.867Z",
    transform: "translate(117.992 854.357)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M22.245,107.845C2.995,104.156,7.82,81.556,3.672,66.788-.236,52.873-1.772,36.1,6.2,25.194c4.849-6.631,12.275-9.694,19.477-11.937,2.693-.839,5.543-1.6,8.264-.751C40.329,14.5,42.621,23.66,44.054,31.282c2.026,10.787,4.731,21.852,10.84,30.3s16.488,13.526,25,9.3C88.636,66.526,92.345,54.7,96.952,44.9,108.18,21.011,140.985-3.365,153.011,2.387s-4.606,34.92-14.718,48.387,14.434,47.838.573,58.273S41.5,111.533,22.245,107.845Z",
    transform: "translate(158.566 988.98)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M18.505,53.307C13.589,70.464,3.253,85.355,1.231,103.381c-.626,5.572.76,13,5.483,13.835,2.946.523,5.679-2.113,6.96-5.252s1.495-6.734,2.018-10.181a49.99,49.99,0,0,1,10.25-23.854c4.905-6.042,11.1-10.375,16.5-15.809s10.178-12.568,10.7-21C54,27.167,43.426,16.106,33.887,7.563,31.143,5.107,23.649-1.832,19.936.821c-4,2.859-.236,9.94.523,14.39A86.841,86.841,0,0,1,18.505,53.307Z",
    transform: "translate(90.833 852.849)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M.35,2.751c-1.539,6.216,3.177,12.3,8,15.566,1.845,1.25,3.846,2.4,5.11,4.423,1.14,1.83,1.549,4.191,2.746,5.971a5.523,5.523,0,0,0,6.209,2.4c4.883-1.656,6.247-9.523,9.532-13.437,3.625-4.319,8-2.538,4.788-9.343C33.359,1.172,1.747-2.889.35,2.751Z",
    transform: "translate(154.784 418.707)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M46.546,55.851c-4.634,16.213-4.267,34.454-10.975,49.576C28.465,121.449,14.49,131.534,5.91,146.488c-2.234,3.892-4.128,8.28-4.26,13.024s1.893,9.876,5.61,11.762c4.991,2.531,10.709-1.7,13.327-7.208s3.179-12.05,4.8-18.092c8.033-30,40.688-44.356,45.676-75.332,1.244-7.728.607-16,3.174-23.228,4.016-11.3,14.058-16.324,21.724-23.453,6.037-5.615,17.728-23.94,1.256-22.9C76.184,2.384,52.679,34.4,46.546,55.851Z",
    transform: "translate(151.888 222.499)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M26.875,8.072c-4.4,4.065-7.7,9.511-10.947,14.883C11.265,30.675,6.542,38.526,3.9,47.518,1.372,56.113.857,65.391.8,74.548Q.728,87.122,1.757,99.69c.2,2.4.9,5.418,2.918,5.754a3.417,3.417,0,0,0,2.381-.759c6.736-4.526,8.46-14.96,9.011-24.172s.955-19.441,6.493-25.83C32.4,43.337,51.219,51.9,61.437,41.034c8.357-8.889,4.417-27.357-3.475-35.7C49.705-3.4,34.573.953,26.875,8.072Z",
    transform: "translate(146.475 143.17)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M48.994,7.815c-10.651,5.13-21.106,11.21-29.871,19.957S3.335,48.176.983,61.541c-.446,2.525-.627,5.483.865,7.415a5.28,5.28,0,0,0,3.979,1.88c7.145.422,13.193-7.655,20.3-6.608C33,65.242,36.892,73.877,40.2,81.128c1,2.2,2.326,4.6,4.4,5.014,3.984.807,5.592-5.71,5.586-10.476l-.024-23.309c-.011-9.278.591-20.029,6.986-25.242,5.433-4.428,30.012-5.449,23.494-20.592C75.4-5.651,55.554,4.656,48.994,7.815Z",
    transform: "translate(373.327 104.193)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M1.845,21.2c2.1,1.782,5.052.8,7.112-.943,3.45-2.915,4.889-5.711,9.063-5.321,1.825.171.858,5.2,4.756,4.518,6.371-1.112,4.2-11.769,1.284-15.574C14.326-8.836-5.715,14.773,1.845,21.2Z",
    transform: "translate(390.109 136.918)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M85.477,58.338C68.544,79.961,50.1,99.977,34.539,123.007s-28.4,49.578-32.214,78.925c-.5,3.851-.336,8.843,2.716,10.41,3.036,1.557,6.093-1.7,8.256-4.568,34.98-46.4,90.844-66.913,143.747-60.225,2.827.356,5.731.778,8.453-.1,7.175-2.31,10.057-12.073,12.983-20.142,10.436-28.776,34.9-49.433,61.44-51.873,7.824-.718,15.8.021,23.469-1.863,11.615-2.854,21.552-11.515,29.876-21.4,5.167-6.134,10.014-13.152,11.689-21.636s-.658-18.7-7.092-23.174c-2.918-2.031-6.335-2.712-9.672-3.216a121.719,121.719,0,0,0-57.034,5.027c-7.386,2.486-14.672,5.736-20.945,10.909C192.118,35,185.326,63.03,169.634,81.342c-12.55,14.646-30.77,22.224-48.532,20.185a4.219,4.219,0,0,1-2.65-1,5.952,5.952,0,0,1-1.226-3.712,40.225,40.225,0,0,1,3.786-20.7c3.59-7.323,9.3-12.747,14.548-18.479s10.333-12.314,12.008-20.582-1.243-18.5-8.023-21.6C134.342,13.077,121.729,12.045,85.477,58.338Z",
    transform: "translate(479.119 9.091)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M13.418,25.635C6.577,34.212,0,44.678.606,56.591c4.748,2.171,9.144-3.325,12.3-7.919,7.332-10.666,17.3-20.058,29.011-20.72,8.883-.5,17.427,4.059,26.157,6.356s19.213,1.58,24.482-6.784a8.043,8.043,0,0,0,1.448-4.693c-.21-3.318-3.2-5.357-5.9-6.371-8.486-3.2-16.838.693-25.1-1.954C56.679,12.478,53.5,6.471,48.26,2.686,35.327-6.648,21.624,15.345,13.418,25.635Z",
    transform: "translate(519.362 106.46)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M102.293,2C91.86,5.668,88.725,21.663,90.669,34.459s7.153,25.151,6.57,38.073c-.116,2.575-.526,5.284-1.978,7.175-3.713,4.837-10.795.885-14.218-4.414C75.955,67.42,74.02,57.376,69.722,48.88,62.835,35.259,49.59,26.4,36.3,26.522S10.21,35.751,3.988,49.495C.815,56.5-.656,65.19,2.14,72.561,6.355,83.673,17.827,87.339,27.5,91.438c16.207,6.865,31,18.6,42.568,33.791a66.559,66.559,0,0,1,10.464,18.578c2.208,6.443,3.058,13.373,3.891,20.224l5.442,44.754c1.311,10.788,4.373,23.958,13.365,26.4,9.206,2.5,16.663-8.72,19.533-19.246a90.925,90.925,0,0,0,2.413-34.894c-1.429-11.464-4.995-23.364-1.87-34.233,4.375-15.224,19.455-21.211,29.227-32.291,8.773-9.944,13.31-24.889,11.949-39.358-2.12-22.554-16.339-30.279-27.615-45.777C128.4,17.751,117.914-3.5,102.293,2Z",
    transform: "translate(535.698 182.218)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M9.6,55.15C8.386,59.173,6.3,62.712,4.69,66.528A51.315,51.315,0,0,0,1.812,95.686a6.192,6.192,0,0,0,1.051,2.788,3.648,3.648,0,0,0,2.373,1.185c6.263.909,10.947-6.5,12.944-13.519S21.207,71.091,25.944,66.3c5.273-5.333,13.363-4.748,19.239-9.122,8.3-6.177,8.9-22.619,1.089-30.01-2.876-2.722-6.827-3.94-9.525-6.845C32.646,15.91,33.912,13.2,31.67,8.16c-2.672-6-5.758-8.695-12-7.748C.054,3.388,14.139,40.078,9.6,55.15Z",
    transform: "translate(633.399 218.283)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M.753,26.134a13.425,13.425,0,0,0,.131,7.323c1.306,3.466,4.755,5.11,7.932,5.415s6.373-.366,9.537.111c8.84,1.334,14.989,10.871,20.472,19.285,4.353,6.679,10.584,13.857,17.414,11.923,6.191-1.752,8.975-12.181,4.813-18.033a15.174,15.174,0,0,0-3.326-3.285c-6.557-4.93-15.11-6.612-19.872-13.886C31.358,25.059,38.441.91,24.58.261,13.908-.239,2.974,15.275.753,26.134Z",
    transform: "translate(558.56 219.137)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M3.5,4.837A98.252,98.252,0,0,0,.946,40.894a9.75,9.75,0,0,0,.909,3.6c1.6,2.892,5.514,2.58,7.6.266s2.825-5.832,3.469-9.151l1.8-9.3c.947-4.886,1.9-9.923,1.2-14.907C15.006,4.741,6.459-6.312,3.5,4.837Z",
    transform: "translate(636.601 347.234)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M120.806,36.329c-5.909,11.087-10.322,24.843-20.532,29.982-7.455,3.752-16.379,1.671-23.509-3.208s-12.8-12.249-18.187-19.633c-6.146-8.42-12.35-17.261-20.689-22.353s-19.536-5.361-25.918,2.5c-7.329,9.023-5.217,24.419.616,35.159S27.174,77.634,33.483,88c9.857,16.187,13.049,37.7,8.393,56.558-2,8.089-5.318,15.587-8.482,23.114A644.278,644.278,0,0,0,5.074,250.587c-1.318,4.924-2.595,10-2.32,15.2s2.416,10.6,6.356,12.995c7.4,4.493,15.6-3.471,20.165-11.48,13.163-23.091,18.488-52.214,34.333-72.782,13.208-17.144,33.247-27.713,40.933-49.128,3.98-11.09,4.117-24.01,9.269-34.38,7.633-15.369,24.114-21.191,33.934-34.683A49.044,49.044,0,0,0,156.605,47.3c-.079-6.805-1.473-13.731-.238-20.346,1.74-9.326,7.626-31.68-8.169-23.667C137.816,8.556,126.652,25.357,120.806,36.329Z",
    transform: "translate(712.533 115.048)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M7.534.5A3.738,3.738,0,0,0,4.38.469,4.5,4.5,0,0,0,2.8,2.7c-3.079,7.592-.131,16.8,3.735,24.048s8.791,14.167,10.015,22.562C19.706,71-2.968,89.385,1.718,110.721c6.526-.136,12.016-5.911,15.235-12.554S21.7,83.915,24.175,76.825C28.568,64.242,36.055,53.26,45.5,45.548c13.56-11.072,31.091-15.305,42.6-29.861,6-7.59,10.966-16.767-.677-14.36C76.122,3.664,65.768,11.9,54.491,14.928,34.458,20.317,25.282,6.52,7.534.5Z",
    transform: "translate(761.506 176.25)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M148.8,9.428c-26.031,18.158-36.815,58.431-63.4,75.452-7.106,4.549-15.2,7.376-21.074,13.92-7.747,8.634-10.086,21.9-12.769,34.158-5.721,26.151-15.841,52.9-35.429,66.549-4.557,3.177-9.8,5.87-12.353,11.355-4.608,9.906,2.065,21.894,8.369,30.68,2.482,3.459,6.021,7.3,9.563,5.771,1.8-.773,2.967-2.756,4.017-4.635q17.342-31.04,31.9-64.139c3.584-8.153,7.1-16.5,12.331-23.268,4.659-6.026,10.513-10.578,16.524-14.616,22.592-15.174,48.367-24.052,68.858-42.891C164.352,89.471,204.166-29.2,148.8,9.428Z",
    transform: "translate(737.635 240.274)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M144.266,119.905c-1.042,11.352-4.118,22.262-7.782,32.762-5.676,16.262-12.89,31.906-22.727,45.028-16.166,21.568-36.812,37.64-56.221,55.078-30.946,27.8-59.422,99.815-52.888,113.51,6.844,14.344,43.47-66.415,53.076-75.6,33.972-32.467,66.716-67,103.542-94.834,11.582-8.754,23.672-16.945,33.335-28.49,2.707-3.234,5.3-6.948,5.955-11.466,2.106-14.568-16.36-26.839-12.148-40.7,2.591-8.527,11.856-10.363,18.117-15.53,5.66-4.671,9.078-12.879,8.8-21.126-.779-22.807-20.2-23.087-33.49-30.74-13-7.486-21.665-21.272-31.24-33.546-5.955-7.634-12.965-17.107-21.912-10.8-17.341,12.215-4.562,33.45,1.872,48.394C139.6,72.849,146.436,96.256,144.266,119.905Z",
    transform: "translate(506.863 436.456)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M5.584,37.929c1.44,4.285-.427,10.62,3.052,12.712C16.341,55.273,35.82,12.164,24.117,2.908,17.218-2.55,10.039.811,5.2,7.32-3.93,19.606,1.468,25.7,5.584,37.929Z",
    transform: "translate(710.131 536.907)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M22.576,24.382c1.2,18.539,7.266,36.863,5.468,55.262-2.9,29.66-28.827,78.041-26.2,82.81s26.579-20.241,33.019-37.527c6.1-16.381,9.6-33.55,11.492-51.35.723-6.781.5-14.97,5.1-19.931,3.289-3.55,11.384-2.057,13.67-5.794,3.809-6.229-6.752-13.661-10.365-17.212C45.29,21.331,37.252,12.823,30.785.318,23.142,3.355,22.038,16.083,22.576,24.382Z",
    transform: "translate(633.894 477.698)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M50.8,33.3C42.238,44.58,31.313,52.915,21.655,62.875S3.24,85.309,1.3,100.4c-1.216,9.442,2.472,21.763,10.56,22.416,4.4.353,8.309-3.029,11.4-6.672,6.705-7.9,11.587-17.683,17.714-26.215s14.121-16.1,23.617-17.169c10.076-1.13,19.87,5.209,30.012,5.675,16.888.774,31.073-14.493,47.67-17.793,17.865-3.553,36,7.116,54.137,6.118,11.9-.656,23.359-6.473,32.3-15.595,4.469-4.557,8.483-10.26,9.573-17.167s-1.584-15.089-7.161-17.719c-5.094-2.4-10.708.266-15.6,2.965C193.77,31.236,170.524,44.865,146.679,39.5c-4.653-1.047-9.258-2.819-13.975-2.78C122.6,36.8,114.188,44.947,105.5,50.847c-2.813,1.911-6.078,3.661-9.247,2.617-5.5-1.811-6.865-10.088-8.018-16.7C86.586,27.337,79.46,1.6,69.164.722,61.64.079,56.17,26.222,50.8,33.3Z",
    transform: "translate(252.029 787.491)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M38.637,24.095c-3.495-8.807-7.59-18.336-15.094-22.3-7.727-4.089-17.7-.115-21.584,8.6S.853,31.263,7.974,36.709c2.372,1.813,5.135,2.961,7.153,5.3,5.6,6.493,2.553,17.3,2.65,26.482.157,14.812,11.132,28.592,23.633,29.669,2.934.254,6.37-.467,7.7-3.532a10.922,10.922,0,0,0,.557-4.963,43.453,43.453,0,0,0-3.078-13.646,11.2,11.2,0,0,1-1.117-3.912c-.1-5.093,6.2-5.87,9.22-9.419,6.224-7.31-2.645-11.841-6.076-16.213C43.876,40.435,41.564,31.466,38.637,24.095Z",
    transform: "translate(182.276 798.95)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M44.589,51.657A286.71,286.71,0,0,0,26.967,14.545C24.336,9.9,21.452,5.213,17.383,2.38S7.74-.938,4.25,2.664C1.683,5.314.734,9.549.38,13.592-.847,27.581,3.869,42.269,12.7,51.951,19.834,59.784,29.875,65.212,33,76.073c2.722,9.452-.89,19.435-3.453,28.818s-3.594,21.2,2.65,27.975c7.363,7.992,19.425,2.96,26.352-5.218,3.02-3.565,7.606-7.9,10.944-4.59,1.923,1.909,1.965,5.28,2.62,8.131,1.932,8.388,11.362,13.037,17.6,8.675s7.191-16.287,1.79-22.245c-9.163-10.107-13.51-21-24.462-28.771C55.218,80.456,50.152,65.908,44.589,51.657Z",
    transform: "translate(131.349 630.97)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M5.78,2.344c-2.675,2.2-3.73,6.209-4.62,9.934C.45,15.257-.26,18.45.555,21.431a14.551,14.551,0,0,0,1.411,3.228C4.937,30,9.248,34.665,14.49,36.073c7.405,1.989,15.964-2.544,22.25,2.584,1.584,1.292,2.834,3.092,4.394,4.423A12.888,12.888,0,0,0,50.3,45.9c5.7-.3,11.917-4.723,11.989-11.486.062-5.891-4.671-10.661-9.545-12-9.642-2.647-20.637,5.525-27.871-4.457C20.4,11.79,16.078-6.12,5.78,2.344Z",
    transform: "translate(178.219 913.026)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M69.09,26.011c-5.906,1.858-12.139,1.734-18.263,2.165A101.137,101.137,0,0,0,18.92,35.8c-5.45,2.28-10.882,5.148-14.943,9.981a13.236,13.236,0,0,0-3.4,7.386,10.3,10.3,0,0,0,9.04,10.657c4.707.328,9.084-2.657,12.626-6.243s6.587-7.873,10.437-10.989c8.887-7.193,20.5-7.1,31.278-8.56a101.012,101.012,0,0,0,36.453-12.467c7.691-4.391,20.247-28.09,4.4-23.975C92.2,4.868,82.425,21.816,69.09,26.011Z",
    transform: "translate(304.424 890.917)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M6.256,25.78c-2.5,2.587-3.959,6.3-4.95,10.067-1.343,5.1-1.512,11.736,2.257,14.827a6.9,6.9,0,0,0,4.856,1.473c8.546-.553,12.81-12.944,20.788-16.453A31.679,31.679,0,0,1,35.97,34.05C45.709,32.122,54.784,26.2,61.3,17.528,74.682-.292,53.772-3.675,43.545,5.587c-4.7,4.258-7.939,9.246-13.63,12.089C22.486,21.388,12.562,19.242,6.256,25.78Z",
    transform: "translate(500.136 610.282)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M16.532,18.251a53.731,53.731,0,0,0-.866,7.36c-.87,7.863-4.828,15.1-10.508,19.209C2.883,46.466-.075,48.675.628,51.767a5.352,5.352,0,0,0,1.361,2.38c4.568,4.98,11.813,3.287,17.35.265s11.191-7.166,17.29-6.106c2,.349,3.933,1.259,5.947,1.487C59.439,51.7,59.78,19.674,52.385,8.2,42.683-6.848,20.752,1.707,16.532,18.251Z",
    transform: "translate(821.273 562.74)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M45.755,14.11c-2.136,6.828-.479,14.6-1.692,21.76-1.966,11.606-10.8,19.266-17.891,27.5C11.414,80.5,2.381,104.378,1.326,129.039c5.553,3.538,12.635,1.006,17.2-3.943s7.2-11.834,9.9-18.44C33.563,94.087,39.4,81.711,47.65,71.769s19.2-17.328,31.064-18.033c8.948-.532,17.777,2.687,26.671,4.29s18.726,1.3,25.683-5.231,8.709-21.056,1.452-27.475c-7.107-6.287-17-2.28-24.283-8.251-6.855-5.621-7.774-12.629-16.874-13.975C78.173,1.145,51.608-4.6,45.755,14.11Z",
    transform: "translate(245.711 270.214)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M1.948,21.141C1.016,23.081.1,25.206.3,27.45a7.192,7.192,0,0,0,6.721,6.316c3.1.14,6-1.481,8.758-3.091,5.35-3.128,11.106-6.445,17.073-5.362,3.9.708,7.4,3.235,10.827,5.626s7.04,4.758,10.975,5.079a8.9,8.9,0,0,0,9.4-6.453c1.282-4.993-1.965-10.363-5.932-12.807C49.262,11.3,38.141,9.752,28.788,4.707,24.3,2.285,18.987-1.384,14.33.9,9.444,3.3,4.441,15.946,1.948,21.141Z",
    transform: "translate(302.724 282.804)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M8.569,6.243C6.21,5.876,3.51,5.794,1.854,7.764A8.027,8.027,0,0,0,.328,11.815c-1.481,10.621,6.477,19.7,13.657,26.547l16.3,15.557c3.6,3.438,7.3,6.938,11.644,8.763,4.105,1.725,8.532,1.839,12.856,1.712,6.782-.2,13.722-1,19.753-4.545,14.992-8.806,10.317-21.886,14.4-36.315,1.636-5.773,16.928-19.894-.268-22.521-6.5-.992-8.482,4.77-13.3,8.672a33.108,33.108,0,0,1-21.494,7.738C38.424,17.5,23.793,8.6,8.569,6.243Z",
    transform: "translate(363.561 212.731)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M294.384,68.152c5.338-5.578,10.88-11.51,13.221-19.5,4.16-14.212-3.7-30.645-14.885-38.276s-24.671-8.3-37.413-7.273A169.094,169.094,0,0,0,189.04,22.785C175.2,30.2,162.061,39.6,147.525,44.955c-24.872,9.168-51.908,5.866-77.886,1.1-16.533-3.03-35.08-6.09-48.336,5.563C11.367,60.355,7.026,75.331,4.19,89.669c-4.123,20.849-5.534,45.168,6.241,61.852,8.407,11.912,21.661,17.092,34.3,20.9Q58.7,176.633,72.9,179.554c2.563.527,5.337.988,7.621-.409,1.711-1.047,2.876-2.985,3.925-4.893,14.332-26.084,18.78-59.224,35.73-82.978,8.693-12.181,20.155-21.1,31.725-29.3,12.1-8.575,24.611-16.609,38.13-21.548a92.827,92.827,0,0,1,42.4-5.076c7.445.851,16.147,3.284,22.094,9.179,10.022,9.932,5.836,17.276,6.032,30.34C261.013,105.784,285.222,77.727,294.384,68.152Z",
    transform: "translate(227.408 22.384)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M75.372,59.03C64.593,43.884,58.359,24.693,46.88,10.281c-3.154-3.962-6.825-7.613-11.214-9.154C24.442-2.815,13.546,8.343,8.278,20.5c-7.8,18-8.795,39.329-6.639,59.627s7.256,40.04,11.1,60.025c9.132,47.416-3.66,137.565,6.084,144.465s20.567-16.863,26.409-30.443C67.874,201.557,94.7,151.435,126.366,105.946c5.883-8.451,28.914-33.061,27.936-44.661-.836-9.9-12.223-9.653-18.476-6.24-11.084,6.051-12.853,21.7-27,23.4C96.224,79.958,83.266,70.121,75.372,59.03Z",
    transform: "translate(42.746 180.38)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M.24,20.679c-.081,4.18.151,9.054,3.026,11.561a5.123,5.123,0,0,0,1.47.906c3.14,1.255,7.031-.964,8.746-4.48,1.994-4.093,1.811-9.183,1.33-13.927C14.282,9.489,11.91-1.27,5.206.2-1.262,1.624.36,14.523.24,20.679Z",
    transform: "translate(89.367 309.486)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M20.767,63.871c1.783,2.25,3.746,4.462,6.2,5.472a5.558,5.558,0,0,0,6.99-1.973,8.661,8.661,0,0,0,1.038-4.255C35.253,50.286,20.609,44,16.836,31.875c-1.46-4.695-1.126-9.82-.991-14.784C16.383-2.653.782-6.932.168,13.435-.348,30.55,11.281,51.9,20.767,63.871Z",
    transform: "translate(53.174 725.642)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M42.391,39.971C26.784,61.263,9.851,82.534,2.539,109.484c-2.445,9.01-1.981,22.061,5.826,24.558,6.733,2.152,12.341-5.991,15.005-13.508C29.221,104.028,30.881,85.07,39.9,70.753c10.329-16.4,44.168-29.973,45.069-52.977.371-9.442-8.328-19.685-16.607-16.417C59.5,4.856,48.814,31.209,42.391,39.971Z",
    transform: "translate(718.194 928.338)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M12.763,6.929A178.328,178.328,0,0,0,2.9,25.89c-1.28,2.862-2.517,5.9-2.543,9.161s1.511,6.812,4.167,7.764c4.6,1.648,7.93-4.595,10.989-8.86,8.622-12.016,32.089-.592,29.454-18.087C42.559-.145,19.95-5.061,12.763,6.929Z",
    transform: "translate(258.714 110.632)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M28.194,12.7c-10.212.511-22.577,2.106-26.62,13.128-2.286,6.229-.947,13.482.519,20.139a17.871,17.871,0,0,0,2.24,6.282c2.245,3.274,6.332,4.012,9.727,2.966s6.3-3.528,9.209-5.807c23.422-18.326,52.812-25.878,80.922-20.793,25.493,4.613,24.711-28.488.4-27.5C79.06,2.145,53.962,11.408,28.194,12.7Z",
    transform: "translate(85.646 78.88)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M41.982,48.291c-5.933-9.65-9.742-20.825-13.566-31.833C26.982,12.326,25.484,8.1,22.908,4.817S16.409-.657,12.8.436C8.315,1.793,5.918,7.414,4.46,12.6A111.393,111.393,0,0,0,2,60.87C3.8,71.5,7.121,81.752,8.611,92.437c1.851,13.259.843,26.916,3.456,40.012,1.585,7.942,4.462,15.459,6.558,23.245,3,11.149-2.141,33.263,4.082,34.485S33.951,180.4,37.2,172.88c11.861-27.487,23.5-55.485,40.228-79.091,2.051-2.895,4.218-5.8,5.3-9.374,4.147-13.752-9.983-12.794-17.1-15.36C56.126,65.629,47.8,57.749,41.982,48.291Z",
    transform: "translate(61.359 207.828)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M5.572,2.132c-.75-1-1.643-2.085-2.762-2.1C.97,0,.14,2.711.074,4.885c-.262,8.672,3.432,16.839,7.02,24.5C9.91,35.405,12.8,41.534,17.069,46.213c5.414,5.936,12.555,9.015,19.506,11.842,6.034,2.454,28.979,14.32,30.4-1.339.585-6.466-6.727-8.211-10.834-9.962-8.21-3.5-16.82-6.063-24.228-11.825C21.531,26.857,13.729,13.042,5.572,2.132Z",
    transform: "translate(68.891 235.809)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M136.635,30.985c-5.344,18.912-18.068,34.548-33.828,41.57-8.274,3.688-17.557,5.277-24.348,11.924-3.925,3.843-6.669,9.072-9.347,14.207L5.555,220.588C3.274,224.965.985,230.626,3.4,235.012c8.527-2.242,13.841-11.875,18.276-20.725q15.612-31.158,31.226-62.315c4.778-9.537,9.586-19.122,15.657-27.549,10.442-14.493,24.554-25.212,40.1-30.466,7.545-2.551,15.441-3.856,22.669-7.425s13.976-10,15.941-19c2.1-9.61-1.6-20.106.364-29.758,1.363-6.692,5.324-12.261,6.723-18.94,1.248-5.955-3.04-20.17-10.281-16.823C138.81,4.447,138.312,25.047,136.635,30.985Z",
    transform: "translate(200.901 149.341)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M17.161,17.545C12.108,20.486,7.005,24.028,4.087,29.72,1.381,35,.9,41.464.689,47.686.14,64.073,1.255,81.389,8.724,95.4c1.053,1.974,2.8,4.119,4.648,3.406,1.583-.612,2.075-2.918,2.3-4.876,1.455-12.575,1.8-25.48,5.117-37.507,6.774-24.6,26.731-42.715,48.488-45.073,3.6-.391,20.216-.7,13.065-8.258C77.958-1.541,63.036,2.044,58.006,2.78A114.783,114.783,0,0,0,17.161,17.545Z",
    transform: "translate(116.482 119.55)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M49.112,7.767a35.446,35.446,0,0,0-7.021-5.695C36.478-.955,29.81.324,24.444,3.682s-9.69,8.565-13.924,13.692C6.213,22.588,1.731,28.174.363,35.328c3.979,5.04,11.053,3.768,15.989.359s9.082-8.531,14.539-10.606c3.318-1.26,6.884-1.3,10.388-1.319,6.506-.044,13.078-.079,19.453,1.627,7.522,2.012,15.915,8.87,23.617,8.816,6.439-.043,6.394-1.127,2.57-5.555C83.23,24.38,75.7,23.034,70.993,21.28A62.455,62.455,0,0,1,49.112,7.767Z",
    transform: "translate(186.616 185.687)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M.3,29.181a12.643,12.643,0,0,0,11.179-2.474c1.692-1.363,3.115-3.15,4.8-4.516,7.318-5.908,14.973-.718,22.5-3.323C46.612,16.154,44.55,4.718,37.3,1.145,26.586-4.137,4.036,18.125.3,29.181Z",
    transform: "translate(158.6 157.197)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M19.286,17.749C5.375,30.469-3.2,52.922,2.311,73.034c1.78,6.495,5.719,13.119,11.423,13.96,3.121.459,6.18-.913,9.026-2.405,4-2.093,8.225-4.923,9.6-9.842,1.364-4.877-.514-10.154-1.865-15.1a75.185,75.185,0,0,1-2.615-17.889c-.138-5.555.387-11.289,2.667-16.088,5.161-10.857,17.2-13.538,27.789-14.311C73.909,10.219,68.26-.944,55.844.784A69.187,69.187,0,0,0,19.286,17.749Z",
    transform: "translate(38.73 58.039)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M55.828,37.429c-3.151,5.776-6.33,11.71-7.666,18.435-2.1,10.56.567,21.858-.988,32.563-1.662,11.431-7.9,20.951-13.7,30.208A545.883,545.883,0,0,0,5.707,168.671c-1.814,3.71-3.634,7.618-3.832,11.931s1.738,9.137,5.253,10.406c4.234,1.531,8.3-2.48,11.026-6.5a79.869,79.869,0,0,0,10.482-22.455c2.52-8.625,3.726-17.828,6.986-26.084C40.34,124.028,48.963,115,55.057,103.988a84.167,84.167,0,0,0,9.985-43.445c-.18-4.7-.729-9.5.275-14.017,2.355-10.6,25.813-32.313,16.72-44.367C75.407-6.629,59.6,30.515,55.828,37.429Z",
    transform: "translate(603.217 899.966)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M30.379,56.99C23.914,61.8,17.235,66.373,11.672,72.554S1.669,86.829.985,95.9c6.9,2.279,12.826-5.31,17.3-11.762A169.069,169.069,0,0,1,68.684,35.9c6.489-3.961,13.26-7.436,19.1-12.6,5.527-4.885,11.12-12.265,11.8-20.753-13.7-7.216-22.684,12-31.87,21.517A305.8,305.8,0,0,1,30.379,56.99Z",
    transform: "translate(808.573 667.896)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M115.233,111.3C94.54,135.489,66.026,147.44,40.654,164.38c-5.325,3.555-10.591,7.4-14.849,12.577a78.29,78.29,0,0,0-8.634,13.964Q10.407,204.027,4.7,217.855c-2.1,5.088-3.865,11.913-.371,15.936,3.921,4.517,10.335.982,14.532-2.962,14.214-13.351,26-29.982,40-43.646,18.305-17.869,39.94-30.251,60.148-45.016,8.977-6.559,17.951-13.92,23.472-24.559,7.674-14.792,7.7-34.045,15.8-48.509,4.685-8.362,11.685-14.414,18.314-20.661,8.778-8.269,19.874-20.11,18.455-35.078C193.9,1.222,184.294-1.007,176.734,5.449,159.112,20.5,149.268,52.8,138.465,74.292,131.811,87.53,124.517,100.442,115.233,111.3Z",
    transform: "translate(771.907 657.573)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M110.976,31.675C105.677,35.228,99.6,36.813,93.783,39A92.679,92.679,0,0,0,68.935,53.127C63.21,57.655,57.817,63,54.057,69.828c-4.036,7.327-5.995,15.968-8.184,24.355a358.379,358.379,0,0,1-27.355,72.276C11.1,180.992,2.447,195.872,2.2,213c-.049,3.367.355,7.057,2.389,9.464,4.044,4.782,10.835,1.193,15.083-3.123a85.989,85.989,0,0,0,18.045-27.778c2.076-5.082,3.793-10.526,7.034-14.651s8.58-6.62,12.944-4.122a17.872,17.872,0,0,1,4.43,4.2c6.383,7.572,12.969,15.308,21.184,19.7s18.546,4.755,25.391-1.89c5.721-5.554,7.915-14.68,9.244-23.353,2.441-15.918,3.02-32.411,7.574-47.616A81.15,81.15,0,0,1,145.465,89.7c6.768-6.746,14.64-11.868,21.2-18.9,15.943-17.11,12.982-48.02-4.455-63.942C142.444-11.185,125.78,21.746,110.976,31.675Z",
    transform: "translate(651.207 903.783)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M28.193,28.893c-4.7,10.365-9.31,20.995-11.279,32.58-2.707,15.932-.424,33.479-6.759,47.814-3.277,7.413-8.846,14.045-8.8,22.485,9.115,3.8,19.863.871,26.473-7.206,5.088-6.217,7.6-14.76,11.827-21.826S51.34,89.813,58.33,92.825c1.852.8,3.548,2.18,5.487,2.564,5.043,1,9.15-5.425,9.18-11.457s-2.612-11.614-4.708-17.166a80.765,80.765,0,0,1-5.234-33.728c.607-8.6,5.926-18.042.511-25.782C49.68-12.586,33.7,16.753,28.193,28.893Z",
    transform: "translate(855.79 983.452)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M1.722,69.419a24.026,24.026,0,0,0-.852,8.067c.312,2.719,1.694,5.463,3.889,6.377s4.685-.232,6.281-2.179a19.681,19.681,0,0,0,3.2-7.141C19.1,57.415,19.56,38.238,27.458,22.838c2.059-4.014,4.591-7.687,6.364-11.9C37.1,3.166,35.817-3.392,29.441,2.806,24.564,7.546,20.706,17.563,17.6,24.013A216.147,216.147,0,0,0,1.722,69.419Z",
    transform: "translate(805.26 1015.664)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M13.714,11.773C7.419,17.2.674,24,.357,33.3a8.27,8.27,0,0,0,1.293,5.3c1.377,1.765,3.663,2.009,5.638,1.616a16.115,16.115,0,0,0,8.179-4.839c3.013-3.107,5.486-7.3,9.313-8.735,4.854-1.815,10.071,1.475,14.161,5.226s8.069,8.257,13.117,9.409a2.151,2.151,0,0,0,2.127-.358,3,3,0,0,0,.6-1.295c1.839-6.906-1.547-15.287-7.292-18.047-2.795-1.342-6.386-1.87-7.658-5.11-2.591-6.59,1.545-15.143-7.178-16.1C26.276-.326,18.387,7.743,13.714,11.773Z",
    transform: "translate(816.44 427.14)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M35.153,34.094C27.033,39.072,18.539,43.565,11.7,50.72S-.2,68.4.947,79.253a11.105,11.105,0,0,0,1.185,4.339c2.5,4.376,8.313,3.114,11.828.027,6.708-5.893,9.985-15.916,16.3-22.391,6.15-6.31,14.511-8.614,21.608-13.355C59.472,42.79,81.45,13.969,70.723,2.79,63.744-4.482,59.62,9.094,57,13.656,51.634,23.007,43.5,28.977,35.153,34.094Z",
    transform: "translate(816.598 282.739)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M37.737,112.938c-2.494,9.51-9.764,18.41-6.95,27.928,9.653,3.438,20.893-3.853,23.5-15.241,1.578-6.888.291-14.332,1.28-21.387,1.417-10.109,7.3-18.39,10.239-27.994a50.624,50.624,0,0,0-3.984-38.287C58.339,31.726,53.5,26.5,50.895,19.711c-1.592-4.158-2.317-8.845-4.677-12.471C42.965,2.238,37.261.359,31.98.33c-13-.073-25.418,9.91-30.241,24.081-2.962,8.7-1.6,20.336,7.732,21.56,7.543.988,13.64-7.014,19.379,2.186,4.122,6.608,3.745,18.688,5.2,26.377C36.388,86.844,41.022,100.411,37.737,112.938Z",
    transform: "translate(851.215 53.554)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M31.434,23.295c-5.743,8.668-12.914,15.852-19,24.184S1.228,65.829.824,76.935s5.162,23.2,14.284,26.129a7.419,7.419,0,0,0,4.585.219c3.127-1.033,4.9-4.883,5.844-8.555,4.1-15.881-.679-34.7,6.533-48.882,2.908-5.718,7.451-9.925,11.561-14.483s8.016-9.929,8.993-16.539c.92-6.234-2.3-16.974-9.04-13.765C38.58,3.442,34.866,18.112,31.434,23.295Z",
    transform: "translate(780.356 26.212)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M29.926.362C23.838.085,17.592.35,11.994,3.048A20.853,20.853,0,0,0,.418,18.337,13.106,13.106,0,0,0,1.8,27.14c2.737,4.358,8.305,4.57,12.5,2.6s7.672-5.589,11.79-7.755A19.458,19.458,0,0,1,40.277,20.4c2.4.653,4.736,1.77,7.186,1.989,9.543.855,7.567-12.485,2.388-17.839C44.7-.776,36.287.653,29.926.362Z",
    transform: "translate(697.498 32.244)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M.621,32.99c-.418,2-.47,4.511.942,5.773a3.34,3.34,0,0,0,2.374.752c5.079-.138,8.079-6.329,11.34-10.867,5.6-7.793,13.963-11.877,22.041-15.6a12.764,12.764,0,0,0,4.48-2.906A5.988,5.988,0,0,0,43.161,4.6C42.455,2.394,40.319,1.35,38.372.861,22.976-3.005,4.161,15.966.621,32.99Z",
    transform: "translate(551.71 14.841)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M21.4,3.715c-6.189,2.433-11,8.059-15.574,13.513C3.551,19.94,1.176,22.86.48,26.618c-.782,4.234.974,9.014,4.149,11.291a7.9,7.9,0,0,0,10.278-.946c1.584-1.629,2.6-3.877,3.886-5.842a18.679,18.679,0,0,1,9.919-7.748c4.693-1.453,10.1-.857,13.942-4.314,2.132-1.917,3.613-5.587,6.124-6.851,2.429-1.223,7.151,1.015,8.942-.6,3.075-2.77.782-3.6-1.954-6.284C47.958-2.337,29.688.456,21.4,3.715Z",
    transform: "translate(395.659 320.915)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M1.14,22.782C-.823,31.421.518,42.4,7.181,46.889c3.533,2.38,7.78,2.415,11.809,2.384,2.9-.022,6.28-.331,7.849-3.184,1.041-1.891.936-4.348.793-6.624-.316-5.069-1.3-9.934.629-14.356,1.566-3.591,5-3.907,5.843-8.778A13.4,13.4,0,0,0,27.562,2.375C14.643-5.457,4.159,9.5,1.14,22.782Z",
    transform: "translate(205.987 438.479)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M.364,35.309c.01,3.676.6,7.78,3.068,10.071,3.217,2.987,8.21,1.209,10.667-2.537S17.091,34.076,17.33,29.3c.212-4.216.254-8.586,1.521-12.569,1.087-3.419,4.721-6.77,5.195-10.267.765-5.643.14-6.481-5.161-6.207C6.184.915.333,23.329.364,35.309Z",
    transform: "translate(541.656 1010.984)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M29.079,1.626C22.037,1.935,14.7,2.45,8.66,6.618S-1.588,19.776,1.021,27.593c2.1,6.3,93.87,1.828,97.746-3.725C119.662-6.066,36.757,1.289,29.079,1.626Z",
    transform: "translate(124.794 30.93)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M1.109,62.8C-.642,87.03,3.994,112.657,16.7,132.143c1.764,2.706,4.669,5.552,7.161,3.956,1.617-1.036,2.11-3.463,2.378-5.628,3.489-28.125-3.932-57.254-.264-85.342,1.2-9.18,3.572-18.122,4.11-27.4C31.143-.493,23.636-5.777,14.4,8.145,5.688,21.262,2.285,46.536,1.109,62.8Z",
    transform: "translate(1.855 180.605)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M.868,26.886C2.449,33.342,6.524,38.506,10.461,43.4L28.406,65.686c2.588,3.215,6.2,6.729,9.6,5.049a6.918,6.918,0,0,0,2.958-3.5c2.614-5.85.787-13.159-1.721-19.2C33.579,34.387,38.546,10.832,26.9,2.83,13.623-6.291-3.305,9.845.868,26.886Z",
    transform: "translate(902.667 405.875)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M9.143,25.1C3.983,33.6-1.307,43.76,1.1,54c2.558.827,5.152-1.3,6.528-3.927s1.937-5.75,3.063-8.544c3.593-8.917,12.083-13.07,19.49-17.63C37.425,19.434,49.558,5.265,34.422.61,25.124-2.248,13.438,18.034,9.143,25.1Z",
    transform: "translate(639.683 6.595)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M30.766,42.4A232.115,232.115,0,0,1,7.138,57.036C3.914,58.774.066,61.671.746,65.839c.787,4.816,6.474,5.32,10.489,4.275C32.454,64.588,52.78,50.028,74.4,54.1c3.829.721,7.666,2.032,11.5,1.583s7.807-3.28,8.439-7.778c.608-4.325-2.088-8.546-5.32-10.8S82.04,34,78.522,32.482C68.471,28.146,55.537-2.983,47.335.825,37.989,5.163,43.389,33.5,30.766,42.4Z",
    transform: "translate(333.618 1073)",
    fill: "none",
    stroke: "#2b3382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectShadow);
export default __webpack_public_path__ + "static/media/project-shadow.dfbc98d7c10a96edd28e9b93e3b93fc0.svg";
export { ForwardRef as ReactComponent };